import React, { useState } from "react";
import { sliderArrowRight } from "../../../assets/img/sliderArrowRight";
import { CreateDropdownMain, CreateDropdownWrapper } from "./CreateDropdown.styled";

export const CreateDropdown = ({ list, active, setActive, maxWidth = null, defaultValue = null }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <CreateDropdownWrapper onClick={() => setShowDropdown(!showDropdown)} showDropdown={showDropdown} style={{ maxWidth: maxWidth }}>
      <span>{active ? active : defaultValue}</span>
      {sliderArrowRight()}
      <CreateDropdownMain showDropdown={showDropdown}>
        {list.map(
          (item, i) =>
            item != active && (
              <span
                onClick={() => {
                  setActive(item);
                  setShowDropdown(false);
                }}
                key={i}>
                {item}
              </span>
            )
        )}
      </CreateDropdownMain>
    </CreateDropdownWrapper>
  );
};
